<template>
  <div class="root">
    <b-container fluid>
      <b-row class="p-1">
        <b-col></b-col>
        <b-col md="6">
          <b-card variant="light" class="p-1 logwrap">
            <div v-if="confirmed" class="" v-html="cmsg"></div>

            <div class="welc">
              <h3 v-if="verify == 'verifying'">
                Your Payment is being Verified, Please Wait...
              </h3>
              <h3 v-if="verify == 'verified'">
                Your Payment has been verified
              </h3>
              <h3 v-if="verify == 'failed'">Transaction Error</h3>
            </div>

            <b-row>
              <div v-if="verify == 'verifying'" class="spindiv m-5 mx-auto">
                <b-spinner class="spinver"></b-spinner>
              </div>

              <div
                v-if="verify == 'verified'"
                class="textdiv alert alert-success m-5 mx-auto"
              >
                {{ verifymsg }}
              </div>

              <div
                v-if="verify == 'failed'"
                class="textdiv alert alert-danger m-5 mx-auto"
              >
                {{ verifymsg }}
              </div>

              <b-button
                v-if="verify != 'verifying'"
                class="w-75 p-2 mt-3 btntxt mx-auto"
                variant="dark"
                @click="proceed"
              >
                {{
                  $route.query.redirect
                    ? "Continue From where you Left Off"
                    : "Proceed to Dashboard"
                }}
              </b-button>
            </b-row>
          </b-card>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
//import NProgress from "nprogress";
import store from "@/store";

export default {
  data() {
    return {
      verify: "verifying",
      verifymsg: "",
      countdown: 5,
      logginin: false,
      frompath: "",
      cmsg: "",
      confirmed: false
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("loginmaster/setOrigin");
    next();
  },
  created() {
    //Delete the Cookies that remembers user. Since the User just verified, make user Login afresh.
    let now = new Date();
    now.setFullYear(now.getFullYear() - 10);
    document.cookie = `remember=;expires=${now.toUTCString()}`;
    document.cookie = `qid=;expires=${now.toUTCString()}`;

    // if (!this.loggedin) {
    //       this.$router.push({
    //           name: "login",
    //           query: { redirect: this.$route.fullPath }
    //       });
    //   }

    if (this.$route.query.reference) {
      let refObj = {
        reference: this.$route.query.reference,
        origin: this.origin
      };

      //Grab the Reference from the url query(reference) and send it as the argument to Verify Action in the Loginmaster Module
      this.verifyPay(refObj).then(response => {
        this.verify = response.verify; // Update the Verify data property to either 'failed' or 'verified' as returned by the Api
        this.verifymsg = response.msg; // Update the Message to Display as returned by the Api
      });
    }
  },
  computed: {
    // Get State Properties from the Store
    ...mapState({
      details: state => state.loginmaster.details,
      loggedin: state => state.loginmaster.loggedIn,
      ongoing: state => state.ongoing,
      start_config: state => state.exam.start_config,
      error: state => state.loginmaster.error,
      errmsg: state => state.loginmaster.errmsg,
      origin: state => state.loginmaster.site_origin
    })
  },
  methods: {
    async proceed() {
      if (!this.loggedin) {
        this.$router.push({
          name: "login"
        });
      } else {
        await this.updateDetails();
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
        } else {
          if(this.details.category == 'Organization'){
            this.$router.push({
              name: "orgdashboard"
            });
          }else{
            this.$router.push({
              name: "dashhome"
            });
          }
          
        }
      }
    },
    ...mapActions("loginmaster", [
      "setErr",
      "verifyPay",
      "setOrigin",
      "updateDetails"
    ])
  }
};
</script>

<style scoped>
.logwrap {
  box-shadow: 5px 5px 15px grey;
  min-height: 500px;
}

.welc {
  text-align: center;
  font-size: 1.3rem;
}

p {
  text-align: left;
  font-size: 16px;
  padding: 5px;
}

.inpdiv {
  padding: 10px;
}

.sign-up {
  text-align: center;
  margin-top: 2rem;
}

.loginput {
  width: 300px;
  padding: 10px;
}

.btn-md {
  font-size: 18px;
  font-weight: bold;
  color: #263056;
  cursor: pointer;
}

.logimg {
  width: 100%;
  height: 60vh;
}
.spinver {
  width: 7rem;
  height: 7rem;
}
.btntxt {
  font-size: 1.5rem;
}
.textdiv {
  font-size: 1.5rem;
}
</style>
